import { getCurrentSystemConfig } from '@/api/api'
import { postAction } from '@/api/manage'

/**
 * 资产单据多级审批按钮状态 mixin
 * 组件需提供 prefixNo：单据前缀字符串（如 'ZG'）或数组（处置/报废 ['ZCCZ','ZCBF']）
 * 状态：multiOn(prefix)=该前缀已开启多级审核；flowOn(prefix)=该前缀已配置发布流程
 * 按钮规则：
 * - 保存：!multiOn（保存后再点审核）
 * - 保存并审核：!multiOn || !flowOn（未开启或开启但未配置流程）
 * - 保存并提交流程：multiOn && flowOn
 * 弹窗默认前缀可覆盖 modalPrefix()（处置单按 disposalType 区分 ZCCZ/ZCBF）
 */
export default {
  data() {
    return {
      approvalStates: {} // { 前缀: { multi: Boolean, flow: Boolean } }
    }
  },
  methods: {
    /** 加载本组件涉及前缀的多级审核与流程配置状态 */
    loadApprovalState() {
      const prefixes = this.approvalPrefixes()
      getCurrentSystemConfig().then((res) => {
        if (!(res && res.code === 200 && res.data)) return
        const mtArr = (res.data.multiBillType || '').split(',').map(p => p.trim()).filter(p => p)
        const flagOn = res.data.multiLevelApprovalFlag === '1'
        const states = {}
        prefixes.forEach(p => { states[p] = { multi: flagOn && mtArr.indexOf(p) > -1, flow: false } })
        this.approvalStates = states
        // 仅对已开启多级审核的前缀查询流程配置（逐前缀，命中即置 flow）
        prefixes.filter(p => states[p].multi).forEach(p => {
          postAction('/api/plugin/workflow/flowDefine/getByBillType', { billType: p }).then((r) => {
            const exist = !!(r && r.code === 200 && r.data && r.data.exist)
            this.$set(this.approvalStates, p, { multi: true, flow: exist })
          }).catch(() => { })
        })
      }).catch(() => { })
    },
    /** 组件声明的全部前缀 */
    approvalPrefixes() {
      return Array.isArray(this.prefixNo) ? this.prefixNo : [this.prefixNo]
    },
    /** 弹窗按钮使用的前缀（处置单按表单 disposalType 覆盖） */
    modalPrefix() {
      return this.approvalPrefixes()[0]
    },
    /** 单据号字母前缀 */
    billPrefix(billNo) {
      const m = /^[A-Za-z]+/.exec(billNo || '')
      return m ? m[0].toUpperCase() : ''
    },
    stateFor(prefix) {
      return (this.approvalStates && this.approvalStates[prefix]) || { multi: false, flow: false }
    },
    multiOn(prefix) {
      return this.stateFor(prefix).multi
    },
    flowOn(prefix) {
      return this.stateFor(prefix).flow
    },
    /** 行按钮：审核可见（未开启多级审核，或开启但未配置流程） */
    canAudit(prefix) {
      const s = this.stateFor(prefix)
      return !s.multi || !s.flow
    },
    /** 行按钮：提交审批可见（开启多级审核且已配置流程） */
    canSubmitFlow(prefix) {
      const s = this.stateFor(prefix)
      return s.multi && s.flow
    },
    /** 提交单据至审批流程（workflow） */
    submitFlowById(bigType, billNo) {
      return postAction('/api/plugin/workflow/workflowTask/add', { bigType, billNo }).then((res) => {
        if (res && res.code === 200) {
          this.$message.success('提交成功')
        } else {
          this.$message.warning((res && res.data && res.data.message) || '提交失败')
        }
        return res
      })
    }
  }
}
